import { useParams } from 'react-router-dom'
import EditSettingForm from './EditSettingForm'
import { useGetSettingsQuery } from './settingsApiSlice'
import { useGetUsersQuery } from '../users/usersApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditSetting = () => {
    useTitle('techSettings: Edit Setting')

    const { id } = useParams()

    const { username, isManager, isAdmin } = useAuth()

    const { setting } = useGetSettingsQuery("settingsList", {
        selectFromResult: ({ data }) => ({
            setting: data?.entities[id]
        }),
    })

    const { users } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            users: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!setting || !users?.length) return <PulseLoader color={"#FFF"} />


    if (!isManager && !isAdmin) {
        if (setting.username !== username) {
            return <p className="errmsg">No access</p>
        }
    }

    const content = <EditSettingForm setting={setting} users={users} />

    return content
}
export default EditSetting